import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function vehicle() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`vehicle/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`vehicle/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('vehicle/create', data);
    }

    function update(data) {
        return axiosInstance.patch('vehicle/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`vehicle/delete`, {
            data: {
                id: id
            }
        });
    }
}
